import styles from "./sectionControlUtil.module.css";
import Button from "../InputControls/Button";
import Checkbox from "../InputControls/Checkbox";
import CheckboxGroup from "../InputControls/CheckboxGroup";
import ComboBox from "../InputControls/ComboBox";
import SelectField from "../InputControls/SelectField";
import DateRange from "../InputControls/DateRange";
import DateTime from "../InputControls/DateTime";
import FileMulti from "../InputControls/FileMulti";
import FileSingle from "../InputControls/FileSingle";
import TextInput from "../InputControls/TextInput";
import MultiInput from "../InputControls/MultiInput";
import RangeInput from "../InputControls/RangeInput";
import TextArea from "../InputControls/TextArea";
import RadioGroup from "../InputControls/RadioGroup";
import Switch from "../InputControls/Switch";
import DynamicLinkList from "../InputControls/DynamicLinkList";
import { existChk } from "@maxis/client-logic/utils/controlsUtil";
import { Tooltip } from "react-tooltip";
import React from "react";
import { ComboBoxCheckList, RichTextEditor, FileUpDown } from "@maxis/components";

/**
 * validation.lengthRange.max of a text control as the input's maxLength, so the field
 * stops at the limit while typing instead of validate() refusing it only on save.
 * An explicit controlOption.maxLength still wins (it is spread after this).
 * Both count UTF-16 units, so the two limits agree.
 */
const lengthLimitProps = (control) => {
  const max = Number.parseInt(control.validation?.lengthRange?.max, 10);
  return Number.isInteger(max) && max > 0 ? { maxLength: max } : {};
};

export const bindControl = (key, control) => {
  if (key.startsWith("txt")) {
    if (control.button) {
      return (
        <>
          <div className={"input_btn_wrap"}>
            <TextInput
              ref={control.ref}
              controlWidth={control.controlWidth}
              {...lengthLimitProps(control)}
              {...control.controlOption}
            />
            <div className="input_btn_box">
              {control.button.search ? (
                <Button
                  ref={control.button.search.ref}
                  buttonType={control.button.search.buttonType}
                  iconType={"btn_search"}
                  onClick={control.button.search.onClick}
                  label={control.button.search.label}
                  authBtn={control.button.search.authBtn}
                  checkAuth={control.button.search.checkAuth}
                  colorType={control.button.search.colorType}
                  visible={control.button.search.visible}
                  {...control.button.search.controlOption}
                />
              ) : null}

              {control.button.refresh ? (
                <Button
                  ref={control.button.refresh.ref}
                  buttonType={control.button.refresh.buttonType}
                  iconType={"btn_reset"}
                  onClick={control.button.refresh.onClick}
                  label={control.button.refresh.label}
                  authBtn={control.button.refresh.authBtn}
                  checkAuth={control.button.refresh.checkAuth}
                  colorType={control.button.refresh.colorType}
                  visible={control.button.refresh.visible}
                  {...control.button.refresh.controlOption}
                />
              ) : null}
            </div>
          </div>
        </>
      );
    }
    return (
      <TextInput
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...lengthLimitProps(control)}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("rtxt")) {
    if (control.button) {
      return (
        <>
          <div className="input_btn_wrap">
            <RangeInput
              ref={control.ref}
              controlWidth={control.controlWidth}
              {...control.controlOption}
            />
            <div className="input_btn_box">
              {control.button.search ? (
                <Button
                  ref={control.button.search.ref}
                  buttonType={control.button.search.buttonType}
                  iconType={"btn_search"}
                  onClick={control.button.search.onClick}
                  label={control.button.search.label}
                  authBtn={control.button.search.authBtn}
                  checkAuth={control.button.search.checkAuth}
                  colorType={control.button.search.colorType}
                  visible={control.button.search.visible}
                  {...control.button.search.controlOption}
                />
              ) : null}

              {control.button.refresh ? (
                <Button
                  ref={control.button.refresh.ref}
                  buttonType={control.button.refresh.buttonType}
                  iconType={"btn_reset"}
                  onClick={control.button.refresh.onClick}
                  label={control.button.refresh.label}
                  authBtn={control.button.refresh.authBtn}
                  checkAuth={control.button.refresh.checkAuth}
                  colorType={control.button.refresh.colorType}
                  visible={control.button.refresh.visible}
                  {...control.button.refresh.controlOption}
                />
              ) : null}
            </div>
          </div>
        </>
      );
    }
    return (
      <RangeInput
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("mtxt")) {
    if (control.button) {
      return (
        <>
          <div className="input_btn_wrap" style={{ border: "1px solid blue" }}>
            <MultiInput
              ref={control.ref}
              controlWidth={control.controlWidth ?? "wpx_150"}
              {...control.controlOption}
            />
            <div className="input_btn_box" style={{ marginTop: "5px" }}>
              {control.button.search ? (
                <Button
                  ref={control.button.search.ref}
                  iconType={"btn_search"}
                  buttonType={control.button.search.buttonType}
                  onClick={control.button.search.onClick}
                  label={control.button.search.label}
                  authBtn={control.button.search.authBtn}
                  checkAuth={control.button.search.checkAuth}
                  colorType={control.button.search.colorType}
                  {...control.button.search.controlOption}
                />
              ) : null}

              {control.button.refresh ? (
                <Button
                  ref={control.button.refresh.ref}
                  buttonType={control.button.refresh.buttonType}
                  iconType={"btn_reset"}
                  onClick={control.button.refresh.onClick}
                  label={control.button.refresh.label}
                  authBtn={control.button.refresh.authBtn}
                  checkAuth={control.button.refresh.checkAuth}
                  colorType={control.button.refresh.colorType}
                  {...control.button.refresh.controlOption}
                />
              ) : null}
            </div>
          </div>
        </>
      );
    }
    return (
      <MultiInput
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("cbo")) {
    if (control.button) {
      return (
        <>
          <ComboBox
            ref={control.ref}
            controlWidth={control.controlWidth}
            {...control.controlOption}
          />
          <Button
            ref={control.button.ref}
            buttonType={control.button.buttonType}
            onClick={control.button.onClick}
            label={control.button.label}
            authBtn={control.button.authBtn}
            checkAuth={control.button.checkAuth}
            colorType={control.button.colorType}
            iconType={control.button.iconType}
            {...control.button.controlOption}
          />
        </>
      );
    }
    return (
      <ComboBox
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("cbc")) {
    if (control.button) {
      return (
        <>
          <ComboBoxCheckList
            ref={control.ref}
            controlWidth={control.controlWidth}
            {...control.controlOption}
          />
          <Button
            ref={control.button.ref}
            buttonType={control.button.buttonType}
            onClick={control.button.onClick}
            label={control.button.label}
            authBtn={control.button.authBtn}
            checkAuth={control.button.checkAuth}
            colorType={control.button.colorType}
            iconType={control.button.iconType}
            {...control.button.controlOption}
          />
        </>
      );
    }
    return (
      <ComboBoxCheckList
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("sel")) {
    if (control.button) {
      return (
        <>
          <SelectField
            ref={control.ref}
            controlWidth={control.controlWidth}
            {...control.controlOption}
          />
          <Button
            ref={control.button.ref}
            buttonType={control.button.buttonType}
            onClick={control.button.onClick}
            label={control.button.label}
            authBtn={control.button.authBtn}
            checkAuth={control.button.checkAuth}
            colorType={control.button.colorType}
            iconType={control.button.iconType}
            {...control.button.controlOption}
          />
        </>
      );
    }
    return (
      <SelectField
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("dt")) {
    return (
      <DateTime
        ref={control.ref}
        controlWidth={control.controlWidth}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("dr")) {
    return <DateRange ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("chk")) {
    return <Checkbox ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("gchk")) {
    return <CheckboxGroup ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("txa")) {
    return (
      <TextArea
        ref={control.ref}
        {...lengthLimitProps(control)}
        {...control.controlOption}
      />
    );
  } else if (key.startsWith("fs")) {
    return <FileSingle ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("fm")) {
    return <FileMulti ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("rdo")) {
    return <RadioGroup ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("swi")) {
    return <Switch ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("dyl")) {
    return <DynamicLinkList ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("fud")) {
    return <FileUpDown ref={control.ref} {...control.controlOption} />;
  } else if (key.startsWith("btn")) {
    return <Button {...control} />;
  } else if (key.startsWith("edi")) {
    return <RichTextEditor ref={control.ref} {...control.controlOption} />;
  }
};

/**
 * Form Section 과 Search Section에서 사용되는 레이아웃을 자동 생성함
 * 수정 사항: options.type에 따라 search_td/th 또는 form_td/th 클래스를 동적으로 부여함
 */
export const createSectionTableLayout = (formControls, numOfCols, options) => {
  const keys = Object.keys(formControls);
  let rows = [];
  let hiddenControls = [];
  
  let currentRow = [];
  let currentGroupId = null;

  // options.type이 'search'면 search_td, 아니면 form_td를 기본으로 사용
  const isSearch = options?.type === "search";
  const tdBaseClass = isSearch ? "search_td" : "form_td";

  keys.forEach((key, keyIndex) => {
    const control = formControls[key];

    if (!existChk(control)) return;

    if (control?.controlOption?.hidden === true) {
      hiddenControls.push({ key, control });
      return;
    }

    const v = { key: key, keyIndex: keyIndex, rowNo: rows.length };
    const rowGroup = control.rowGroup || null;

    if (rowGroup === null || rowGroup !== currentGroupId) {
      if (currentRow.length > 0) {
        rows.push(currentRow);
      }
      currentRow = [];
      currentGroupId = rowGroup;
    }

    // handleLabel 호출 시 options 전달하여 적절한 th 클래스 생성
    currentRow.push(handleLabel(control, options, v));
    
    const component = bindControlProxy(key, control);
    currentRow.push(
      <div
          key={`td_${keyIndex}`}
          className={`${tdBaseClass} ${control.tdWidth ?? ""} ${options?.tdClass ?? ""} ${control.tdClass ?? ""}`}
          {...(control.flex ? { style: { flex: control.flex } } : {})}
        >
        {component}
        {control.afterText && (
          <span ref={control.afterText.ref}>{control.afterText.text}</span>
        )}
      </div>
    );

    if (rowGroup === null) {
      rows.push(currentRow);
      currentRow = [];
      currentGroupId = null;
    }
  });

  if (currentRow.length > 0) {
    rows.push(currentRow);
  }

  // 히든 컨트롤 처리
  if (hiddenControls.length > 0) {
    const hiddenRow = hiddenControls.map(({ key, control }, index) => {
      const component = bindControlProxy(key, control);
      return (
        <div key={`td_hidden_${index}`} style={{ display: "none" }}>
          {component}
          {control.afterText && (
            <span ref={control.afterText.ref}>{control.afterText.text}</span>
          )}
        </div>
      );
    });
    rows.push(hiddenRow);
  }

  return rows;
};

const bindControlProxy = (key, control) => {
  let beforeComponentArr = [];
  let afterComponentArr = [];
  if (control?.beforeComponents) {
    const keys = Object.keys(control?.beforeComponents);
    beforeComponentArr = keys?.map((item) => {
      return {
        key: item,
        control: control?.beforeComponents[item],
      };
    });
  }

  if (control?.afterComponents) {
    const keys = Object.keys(control?.afterComponents);
    afterComponentArr = keys?.map((item) => {
      return {
        key: item,
        control: control?.afterComponents[item],
      };
    });
  }

  return (
    <>
      {additional(beforeComponentArr)}
      {bindControl(key, control)}
      {additional(afterComponentArr)}
    </>
  );
};

const additional = (additionalComponentArr = []) => {
  const result = additionalComponentArr.length
    ? additionalComponentArr.map((item) => {
        return bindControl(item.key, item.control);
      })
    : null;

  return result;
};

// label 처리 (th 클래스 분기 로직 포함)
const handleLabel = (control, options, v) => {
  const { key, keyIndex } = v || {};
  const { align, cssClass } = control.labelOption || {};

  // options.type에 따라 search_th 또는 form_th 결정
  const isSearch = options?.type === "search";
  const thBaseClass = isSearch ? "search_th" : "form_th";

  const textAlign = align ? styles[align] : styles["left"];

  return control.label ? (
    <div
      key={`th_${keyIndex}`}
      className={`${thBaseClass} ${control.labelWidth ?? ""} ${
        options?.tdClass ?? ""
      } ${textAlign} ${cssClass ?? ""} ${control.thClass ?? ""}`}
    >
      <label
        className={control.validation?.required && control.showRequiredMark !== false ? `req` : ""}
        id={key + "label"}
      >
        {control.label}
        {handleToolTip(control, v)}
      </label>
    </div>
  ) : null;
};

// create tooltip (기존과 동일)
const handleToolTip = (control, v) => {
  const { tooltip, tooltipMessage } = control || {};
  const { keyIndex, rowNo } = v || {};

  return tooltip ? (
    <>
      <svg
        data-tooltip-id={`my-tooltip-${keyIndex} + ${rowNo}`}
        data-tooltip-html={tooltipMessage ?? ""}
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="question-circle"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className="svg-inline--fa fa-question-circle fa-w-16 fa-sm"
        style={{
          height: "1em",
          fontSize: "0.875em",
          width: "1em",
        }}
      >
        <path
          fill="currentColor"
          d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
        ></path>
      </svg>
      <Tooltip
        id={`my-tooltip-${keyIndex} + ${rowNo}`}
        place="bottom"
        style={{
          zIndex: 9999,
          textAlign: "left",
          backgroundColor: "white",
          color: "black",
          borderRadius: "15px",
        }}
        opacity={1}
        border={"black solid 1px"}
      />
    </>
  ) : null;
};
